<template>

     <v-card
            class="mx-4 my-4"
            role="listitem"
            outlined
        >


        <FavouritesButton
            :item="cms_page"
        />
        <div
            class="cms_page__link"
            ripple
        >
            <v-list-item three-line>
            <v-list-item-content @click="handleContentClick($event)">
                <router-link
                    :to="{ name: 'cms_page', params: { id: cms_page.id }}"
                    class="cms_page__link"
                    ripple
                >
                    <v-list-item-title class="headline "><p>{{cms_page.page_title}}</p></v-list-item-title>
                </router-link>

            </v-list-item-content>

            </v-list-item>

            <v-card-actions>
                <v-btn class="v-btn--outlined white--text" :to="{ name: 'cms_page', params: { id: cms_page.id }}" text>{{hubbdata.catagories.info}}</v-btn>
            </v-card-actions>
        </div>

        </v-card>
</template>

<script>
// import favourites from "@/favourites";
import hubbdata from "@/hubbdata";
import FavouritesButton from '@/components/Favourites/FavouritesButton.vue';

import moment from 'moment';

  export default {
    name: 'CmsPageItem',
    props: {
        cms_page: Object,
    },

    components: {
        FavouritesButton
    },

    computed: {
        hubbdata() {
            return hubbdata.getters.translations;
        },
    },
    methods: {
        //handleContentClick is in global sharedMethods mixin
    },
    filters: {
        formatDate(value) {
            if (value) {
                return moment(String(value)).format('DD/MM/YYYY');
            }
        }
    },
  }

</script>

<style lang="scss" scoped>
    .event {
        img {
            max-width: 100%;
            width: 100%;
        }
    }
    .v-btn--outlined {
        text-transform: capitalize;
        margin: 0 auto;
        background-color: #e9e8e6;
        outline: 1px solid $dark;
        color: $dark!important;
        font-weight: 18px;
        font-weight: bold;
    }



    .cms_page__link {
        text-decoration: none !important;

        .v-card__actions {
            @media (max-width: 576px) {
                display: flex;
                justify-content: center;
            }

            @media (min-width: 577px) {
                margin-left: 8px;
            }
        }

        .email {
        width: 165px;
        white-space: normal;
        }

  }

</style>
